import { useToasts } from 'react-toast-notifications'
import { useCallback } from 'react'
import { ApolloError } from '@apollo/client'
import { useGetLabOrderResultPdfLazyQuery } from './getLabOrderResultPdf.generated'

export default function useOpenLabReport() {
  const [getReport, getReportStatus] = useGetLabOrderResultPdfLazyQuery()
  const { addToast } = useToasts()

  const openLabReport = useCallback(
    async (orderID: string) => {
      try {
        const report = await getReport({ variables: { orderID } })
        if (report.error) {
          throw report.error
        }
        if (!report.data?.labOrder?.resultPdf) {
          throw new Error('Missing labOrder.resultPdf')
        }

        openPdf(report.data.labOrder.resultPdf.data)
      } catch (err) {
        if (err instanceof ApolloError && err.graphQLErrors[0]?.extensions.clientError) {
          addToast(err.message)
        } else {
          addToast('Failed to open lab results')
        }
      }
    },
    [addToast, getReport]
  )

  return [openLabReport, getReportStatus] as const
}

function openPdf(byte: number[]) {
  const blob = new Blob([new Uint8Array(byte)], { type: 'application/pdf' })
  const link = document.createElement('a')
  link.target = '_blank'
  const objectUrl = window.URL.createObjectURL(blob)
  link.href = objectUrl
  link.click()

  setTimeout(() => {
    window.URL.revokeObjectURL(objectUrl)
  }, 1000)
}
